import { makeStyles, Button, Container, Grid, Typography, Paper, Box, IconButton } from "@material-ui/core";
import React, { useRef, useEffect, useState, useMemo, useContext } from "react";
import { useLocation } from 'react-router-dom'
import TextComponent from "../commonComponents/TextComponent";
import VideoJWPlayer from "../commonComponents/VideoPlayer";
import DocumentViewer from "../commonComponents/DocumentViewer";
import { CurriculumMasterData, CurriculumDataService } from "../../../services";
import QuizViewContainer from "./QuizViewContainer";
import Helper from "../../../common/Helper";
import Loader from '../../../sharedComponents/Loader/Loader'
import DialogComponent from '../commonComponents/DialogComponent';
import DocImage from '../../../images/memo_ic.png'
import DescriptionIcon from '@material-ui/icons/Description';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { red } from "@material-ui/core/colors";
import moment from "moment";
import { AppDataContext } from '../../../common/AppContext';

const useStyles = makeStyles((theme) => ({
    content: {
        display: 'flex',
        flexGrow: 1,
        padding: theme.spacing(3),
        background: '#f1f1f1',
        flexDirection: 'column',
        justifyContent: 'space-between'

    },
    contentPaper: {
        // height: '100%'
    },
    docResources: {
        background: theme.palette.primary.main,
        color: '#ffffff',
        padding: '0 8px',
        borderRadius: '16px',
        cursor: 'pointer',
    }

}));

const CourseContentContainer = ({ content, updateNextBtnState, enableNext, handleNextClick, onStartClick, currentSec, handlePrevClick, isFirst, isLast, curriculumDescription,
    disableStart, isPreview, curriculumFlow }) => {
    const classes = useStyles();
    const { addSnackMessages } = useContext(AppDataContext);
    const { state } = useLocation();
    const listInnerRef = useRef();
    //const [atBottom, setAtBottom] = useState(false)
    // const [content, setContent]=useState([])
    // useEffect(())
    const [document, setDocument] = useState()
    const [currentQuestion, setCurrentQuestion] = useState()
    const [showNextPrev, setShowNextPrev] = useState(true)
    //const [loadingImage, setLoadingImage] = useState(false)
    const [sectionTime, setSectionTime] = useState({ startTime: null, endTime: null })
    useEffect(() => {
        const loadData = async () => {
            let mediaURL = undefined
            //if (content?.contentGalleryID !== 0) {
            // mediaURL = await CurriculumMasterData.getMediaURL(content?.contentGalleryID)
            updateNextBtnState(false)
            // setLoadingImage(false)
            setCurrentQuestion({ ...content })
            //} else {
            //     updateNextBtnState(false)
            // setCurrentQuestion({ ...content, mediaURL: mediaURL })
            // }
            setSectionTime({ startTime: moment().utc().format(), endTime: null })


        }
        if (content) {
            // if (content?.contentGalleryID !== 0) {
            //setCurrentQuestion()
            //     setLoadingImage(true)
            // }
            loadData()
        }

    }, [content])

    const closeFileViwer = () => {
        setDocument(false);
    }



    const onScroll = () => {
        if (listInnerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
            const isNearBottom = scrollTop + clientHeight >= scrollHeight;
            let ext = currentQuestion?.documentName?.split('.').pop();
            if (isNearBottom && ext !== 'mp4' && ext !== 'video' && ext != 'mov') {
                console.log("Reached bottom");
                //setAtBottom(true)
                setTimeout(() => {
                    updateNextBtnState(true)
                }, 500);

            }
        }
    };

    const onDocumentClick = (name) => {

        setDocument(name)
    }

    useEffect(() => {
        const listInnerElement = listInnerRef.current;

        // setCurrentQuestion()

        if (listInnerElement) {

            listInnerElement.addEventListener("scroll", onScroll);
            const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
            const isNearBottom = scrollTop + clientHeight >= scrollHeight;
            let ext = currentQuestion?.documentName?.split('.').pop();
            if (isNearBottom && ext !== 'mp4' && ext !== 'video' && ext != 'mov') {
                console.log("Reached bottom");
                setTimeout(() => {
                    updateNextBtnState(true)
                }, 500);

                // DO SOMETHING HERE
            }
            else {
                updateNextBtnState(false)
            }
            // Clean-up
            return () => {
                listInnerElement.removeEventListener("scroll", onScroll);
            };
        }
    }, [currentQuestion]);

    const handleStartClick = () => {
        onStartClick()
    }

    const handlestartedQUiz = () => {
        setShowNextPrev(false)
        setSectionTime({ startTime: moment().utc().format(), endTime: null })
    }

    const handleQuizEnd = async (savetoDB = false, updatesQuizResult) => {
        if (savetoDB) {
            let _payload = {
                curriculumID: content.curriculumID,
                sectionID: content.parentSectionID,
                subSectionID: content.sectionID,
                startTime: sectionTime.startTime,
                endTime: moment().utc().format()
            }

            let loggedIn = Helper.isUserLoggedIn()
            if (!isPreview && !state?.isPublic && loggedIn) {
               // if (!isLast) {
                    let result = await CurriculumDataService.updateSectionStartEndTime(_payload);
                    if (result && result.data == 0 && result.message && result.message.length > 0) {
                        addSnackMessages([{
                            open: true,
                            message: result.message,
                            severity: 'error'
                        }]);
                        return;
                    }
                // } else {
                //     let result = await CurriculumDataService.updateSectionStartEndTime(_payload);

                // }
            }
            console.log('section', _payload)
        }
        setSectionTime({ ...sectionTime, endTime: moment().utc().format() })
        setShowNextPrev(true)
        handleNextClick(updatesQuizResult)
        updateNextBtnState(false)
    }

    const getIcon = (ext) => {

        switch (ext) {
            case 'pdf':
                return <PictureAsPdfIcon fontSize="medium" style={{ color: red[500] }} />

            default:
                return <DescriptionIcon fontSize="medium" style={{ color: '#ffffff' }} />
        }
    }

    const renderQuestionElement = () => {
        if (currentQuestion) {
            if (currentQuestion?.sectionTypeName == 'Content') {
                let ext = currentQuestion?.documentName?.split('.').pop();
                switch (ext) {

                    case 'video':
                    case 'mov':
                    case 'mp4':
                        return <Box component='div' height='calc(100vh - 295px)' overflow='auto'>
                            {/* <VideoJWPlayer videoURL={currentQuestion.mediaURL} handleComplete={updateNextBtnState} /> */}
                            <DocumentViewer id={currentQuestion?.sectionID} documentName={currentQuestion.documentName} fileExtension={ext} minHeight='300px' handleComplete={updateNextBtnState} />
                            <Box component='div' flexGrow={1} display='flex' mt={2}>
                                <div dangerouslySetInnerHTML={{ __html: currentQuestion?.longDescription }} />
                            </Box>
                        </Box>

                    // updateNextBtnState(true)
                    // return <Box height='calc(100vh - 295px)' overflow='auto'><DocumentViewer documentName={currentQuestion.mediaURL} fileExtension={ext} minHeight='300px' />
                    //     <Box component='div' flexGrow={1} display='flex' mt={2}>
                    //         <Typography variant="body1" >
                    //             {Helper.stripHtmlTags(currentQuestion?.longDescription)}
                    //         </Typography>
                    //     </Box></Box>
                    case 'pdf':
                    case 'txt':
                    case 'xlsx':
                    case 'xls':
                    case 'doc':
                    case 'docx':
                    case 'ppt':
                    case 'pptx':
                        updateNextBtnState(true)
                        return <Box height='calc(100vh - 295px)' overflow='auto'>
                            <Box display='flex' flexDirection='row' alignItems='center' justifyContent='end'>
                                <Box component='div' className={classes.docResources} onClick={() => onDocumentClick(currentQuestion.documentName)}>
                                    <Typography variant="caption">{currentQuestion?.documentTitle}</Typography>
                                    <IconButton >
                                        {getIcon(ext)}
                                    </IconButton>
                                </Box>
                                {/* <img src={DocImage} onClick={() => onDocumentClick(currentQuestion.documentName)} style={{ width: '25px', aspectRatio: '1/1', marginLeft:'8px',cursor:'pointer' }}></img> */}
                            </Box>
                            <Box component='div' flexGrow={1} display='flex' mt={2}>
                                <div dangerouslySetInnerHTML={{ __html: currentQuestion?.longDescription }} />
                            </Box>

                        </Box>
                    case 'jpg':
                    case 'png':
                    case 'jpeg':
                    case 'svg':
                    case 'bmp':
                        updateNextBtnState(true)
                        return <Box height='calc(100vh - 295px)' overflow='auto'>
                            <DocumentViewer id={ext} documentName={currentQuestion.documentName} fileExtension={ext} minHeight='300px' />
                            <Box component='div' flexGrow={1} display='flex' mt={2}>
                                <div dangerouslySetInnerHTML={{ __html: currentQuestion?.longDescription }} />
                            </Box></Box>
                    default:
                        return <Box height='calc(100vh - 295px)' overflow='auto' ref={listInnerRef}><TextComponent value={currentQuestion?.longDescription} /></Box>
                }
            } else {
                return <Box height='calc(100vh - 200px)' overflow='auto' >
                    <Box component='div' flexGrow={1} display='flex' height='100%'>
                        <QuizViewContainer isPreview={isPreview} curriculumID={currentQuestion?.curriculumID} curriculumFlow={curriculumFlow}
                            sectionID={currentQuestion.parentSectionID} subSectionID={currentQuestion?.sectionID}
                            questions={currentQuestion?.questions} startedQuiz={handlestartedQUiz} handleQuizEnd={handleQuizEnd}
                            showReviewPage={currentQuestion?.showReviewPage ?? true} />
                    </Box>
                </Box>
            }
        } else {
            // if (loadingImage) {
            //     <Loader isLoading={true}/>
            // } else {
            return <Box height='calc(100vh - 280px)' overflow='auto' component='div' flexGrow={1} display='flex' flexDirection='column'>
                <Box component='div'>
                    <div dangerouslySetInnerHTML={{ __html: curriculumDescription }} />
                </Box>

                {/* <Typography variant="body1">
                        {Helper.stripHtmlTags(curriculumDescription ?? '')}

                    </Typography> */}
                <Box component='div' display='flex' justifyContent='center' position='sticky' bottom={0} style={{ background: '#ffffff' }}>
                    <Button variant="contained" color='primary' className={classes.startButton} onClick={handleStartClick} disabled={disableStart}>Start</Button>
                </Box>
            </Box>
            // }
        }
    }

    const btnNextClick = async () => {
        setSectionTime({ ...sectionTime, endTime: moment().utc().format() })
        // console.log(content.sectionID);
        let loggedIn = Helper.isUserLoggedIn()
        let _payload = {
            curriculumID: content.curriculumID,
            sectionID: content.parentSectionID,
            subSectionID: content.sectionID,
            startTime: sectionTime.startTime,
            endTime: moment().utc().format()
        }
        if (!isPreview && loggedIn) {

            let result = await CurriculumDataService.updateSectionStartEndTime(_payload);
            if (result && result.data == 0 && result.message && result.message.length > 0) {
                addSnackMessages([{
                    open: true,
                    message: result.message,
                    severity: 'error'
                }]);
                return;
            }

        }
        console.log('section', _payload)
        handleNextClick();
    }

    return (
        <main className={classes.content}>
            {/* <Toolbar /> */}
            <Box component="main" >
                <Paper square className={classes.contentPaper}>
                    <Container maxWidth="false">
                        <Grid container spacing={2} mt={0}>

                            {/* //{content.map((ques, i) => { */}

                            {/* <Grid item xs={12}>
                                <Typography variant="body1">
                                    {currentQuestion?.questionTitle ?? ''}
                                </Typography>
                            </Grid> */}
                            <Grid item xs={12} style={{ height: currentQuestion?.sectionTypeName == 'Content' ? 'calc(100vh - 220px)' : 'calc(100vh - 190px)' }}>

                                {renderQuestionElement()}
                            </Grid>

                            {/* //})} */}

                        </Grid>
                    </Container>
                    {document && <DialogComponent
                        handleClose={closeFileViwer}
                        open={document ? true : false}
                        title="View"
                        childComponent={
                            <DocumentViewer
                                documentName={document}
                                fileExtension={document?.split('.').pop()}
                            />
                        }>
                    </DialogComponent>
                    }
                </Paper>
            </Box>
            {
                showNextPrev && <Box style={{ visibility: currentSec != '' ? 'visible' : 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '16px 0', position: 'sticky', bottom: 0 }}>
                    <Button style={{ visibility: isFirst == true || isFirst == undefined ? 'hidden' : 'visible' }} variant="contained" size="small" color="secondary" onClick={handlePrevClick}>
                        Previous
                    </Button>
                    <Button variant="contained" size="small" color="primary" disabled={!enableNext} onClick={btnNextClick}>
                        {isLast ? 'Finish' : 'Next'}
                    </Button>
                </Box>
            }
        </main >
    )
}

export default CourseContentContainer;